
export const CONFIG_LAYER_AU = {
	ASSET_CLASS_COLORS: {
		'Empty': '#dddddd',
		'International/Global Fixed Income': '#B287DF',
		'Global Fixed Income': '#9CD7BD',
		'Alternatives': '#CC0018',
		'Alternative': '#CC0018',
		'Cash': '#FFCE00',
		'Australian Fixed Income': '#008B5C',
		'International Fixed Income': '#9BD7BE',
		'Emerging Equity': '#B287DF',
		'Emerging Markets Equities': '#B287DF',
		'Emerging Market Equities': '#B287DF',
		'Developed Equity': '#CDB9E6',
		'Developed Markets Equities': '#CDB9E6',
		'Developed Market Equities': '#CDB9E6',
		'Australian Equity': '#6E3FA3',
		'Australian Equities': '#6E3FA3',
		'Factor Equities': '#E6D2FB',
		'Property & Infrastructure': '#E6D2FB',
		'Cash & Cash Alternatives': '#FFCE00',
		'Default': '#772654',
		'Other': '#A5A5A5'
	},
	DROP_DOWN_FILTERS: [
		{
			'meFilterId': 'riskProfile',
			'meFilterKey': 'riskProfile',
			'meFilterName': 'Risk Tolerance',
			'meFilterGroup': 'Standard',
			'applicability': 'portfolio',
			'options': ['conservative', 'moderate', 'balanced', 'growth', 'aggressive']
		}, {
			'meFilterId': 'tradeFrequency',
			'meFilterKey': 'tradeFrequency',
			'meFilterName': 'Investment Approach',
			'meFilterGroup': 'Standard',
			'applicability': 'family',
			'options': ['monthly', 'quarterly', 'semi-annually', 'annually']
		}, {
			'meFilterId': 'vehicle',
			'meFilterKey': 'vehicle',
			'meFilterName': 'Investment Vehicle',
			'meFilterGroup': 'Standard',
			'applicability': 'family',
			'options': ['etf only', 'etf and mf', 'mf only']
		}
	],
	SHOW_DOWNLOAD_HOLDINGS_BUTTON_ON_FIND_AND_COMPARE: false,
	DROPDOWN_FILTER_MAPPING: {
		'all_etf': 'etf only',
		'mutual_fund_and_etf': 'etf and mf',
		'tax_aware': 'tax aware',
		'sustainable': 'esg',
		'high_net_growth': ''
	},
	MODEL_CATEGORY_MAPPING: {
		'mas - mps managed models': 'AUS_MODELS'
	},
	PDF: { ENABLE_CUSTOMIZATION: true },
	PDF_INVESTMENT_PAGES_MAPPING: {
		'mas - mps managed models': 'AUS_MODELS'
	},
	SHOW_INVESTMENT_PDF_PAGES: false,
	SHOW_MODEL_OVERVIEW_PDF_PAGE: false,
	ESG_RATING_MAPPING: [
		{
			'category': 'Laggard',
			'high': 'B',
			'low': 'CCC'
		},
		{
			'category': 'Average',
			'high': 'A',
			'low': 'BB'
		},
		{
			'category': 'Leader',
			'high': 'AAA',
			'low': 'AA'
		}
	],
	SHOW_ANALYSIS_BUTTON: false,
	RISK_PROFILE_KEYS: [
		'riskProfile', '12mTrailingYield', '1YrReturn', '5YrReturn', 'estimatedRisk'
	],
	RISK_PROFILE_SORT_ORDER: ['conservative', 'moderate', 'balanced', 'growth', 'aggressive'],
	FAMILY_DETAILS_TAB: [
		{ route: 'latest-holdings', label: { dcrKey: 'FAMILY_LATEST_HOLDINGS_LABEL', dcrValue: 'Latest Holdings (%)' } },
		{ route: 'changes-holdings', label: { dcrKey: 'FAMILY_CHANGES_HOLDINGS_LABEL', dcrValue: 'Changes to Holdings (%)' } },
		{ route: 'commentary', label: { dcrKey: 'FAMILY_COMMENTARY_LABEL', dcrValue: 'Trade Rationale' } },
		{ route: 'performance-commentary', label: { dcrKey: 'FAMILY_PERFORMANCE_COMMENTARY_LABEL', dcrValue: 'Performance Commentary' } },
		{ route: 'performance', label: { dcrKey: 'FAMILY_PERFORMANCE_LABEL', dcrValue: 'Performance (%)' } },
		{ route: 'esg-metrics', label: { dcrKey: 'FAMILY_ESG_METRICS_LABEL', dcrValue: 'Esg Metrics' } },
		{ route: 'additional-resources', label: { dcrKey: 'FAMILY_ADDITIONAL_RESOURCES_LABEL', dcrValue: 'Additional Resources' } }
	],
	ESG_CARBON_EQUIVALENCIES: {
		CARBON_EMISSION_DIFFERENCE: 1,
		HOMES_ENERGY_PER_YEAR: 0.11315,
		PASSENGER_VEHICLES_DRIVEN: 3742.69,
		PETROL_CONSUMED: 386.4525
	},
	SHOW_DROPDOWN_FILTERS_MORE_LESS_BUTTON: false,
	SHOW_SEARCH_BUTTON: false,
	SHOW_MODELS_COMPARISON_CHECKBOX: false,
	SHOW_RISK_INDICATOR: false,
	HAS_COLLAPSED_DISCLOSURE: false,
	ENABLE_ADD_TO_COMPARE_MODEL: false,
	ENABLE_PERFORMANCE_BENCHMARK: false,
	ENABLE_NET_PERFORMANCE: false,
	SHOW_MODEL_LIST_PERFORMANCE_DISCLOSURE: true,
	HOLDINGS_TABLE_HEADER_COLUMNS: ['latestAllocation'],
	LATEST_HOLDINGS_HEADER_COLUMNS: [
		{
			headerDcr: 'LATEST_ALLOCATION',
			headerFallbackText: 'Latest Allocation',
			tooltipDcr: 'LATEST_ALLOCATION_TOOLTIP',
			field: 'latestAllocation'
		}
	],
	CHANGES_TO_HOLDINGS_HEADER_COLUMNS: [],
	ENABLE_HOLDINGS_TABLE_HEADER_V2: true,
	SHOW_FUND_PERF_TABLE_LINK: false,
	PERFORMANCE_TABLE_DISABLE_COLUMNS_LIST: ['estimatedRisk', 'performanceType', 'tenYear', 'inception', 'modelName'],
	PERFORMANCE_TABLE_DISABLE_COLUMNS_LIST_PDF: ['estimatedRisk', 'performanceType', 'tenYear', 'inception'],
	PERFORMANCE_TABLE_COLUMN_WIDTH: [19, 11, 11, 10, 10, 11, 11, 11],
	MULTI_ROW_LEFT_HEADER: false,
	SHOW_PDF_MODULARITY: false,
	SHOW_PDF_GLOSSARY_PAGE: false,
	ENABLE_FAMILY_SPECIFIC_PERFORMANCE_BENCHMARK_DISCLOSURE: false,
	ESG_RATINGS_RANGE_SCALE: {
		'0-1.4': 'CCC',
		'1.4-2.9': 'B',
		'2.9-4.3': 'BB',
		'4.3-5.7': 'BBB',
		'5.7-7.1': 'A',
		'7.1-8.6': 'AA',
		'8.6-10': 'AAA'
	},
	SHOW_ESG_PDF_PAGES: true,
	MODEL_FAMILIES_V2_1_API_ENABLE: true,
	SHOW_DOWNLOAD_HOLDINGS_BUTTON: false,
	ENABLE_PERFORMANCE_PAGE_BOTTOM_DISCLOSURE: false,
	SHOW_MODEL_LIST_DISCLOSURE: false,
	SHOW_FAMILY_LIST_HEADER_DISCLOSURE: false,
	SHOW_FAMILY_DESCRIPTION: true,
	ENABLE_CUSTOM_FEE: false,
	ENABLE_PORTFOLIO_LINKS: false,
	ENABLE_PERFORMANCE_BOX_DISCLOSURE: false,
	ENABLE_ROUND_OFF_EQUIVALENCY_SCORE: true,
	ENABLE_HOLDINGS_TABLE_HEADER_COLUMN_WIDTH: false,
	ESG_SCORE: {
		'874741': [
			{
				'name': 'overallScore',
				'coverageThreshold': 0,
				'coverage': 0.854352,
				'total': 7.3
			},
			{
				'name': 'carbonScore',
				'coverageThreshold': 0,
				'coverage': 0.826489,
				'total': 44
			}
		],
		'874742': [
			{
				'name': 'overallScore',
				'coverageThreshold': 0,
				'coverage': 0.323189,
				'total': 7.4
			},
			{
				'name': 'carbonScore',
				'coverageThreshold': 0,
				'coverage': 0.284122,
				'total': 38
			}
		],
		'874743': [
			{
				'name': 'overallScore',
				'coverageThreshold': 0,
				'coverage': 0.484405,
				'total': 7.6
			},
			{
				'name': 'carbonScore',
				'coverageThreshold': 0,
				'coverage': 0.453222,
				'total': 35
			}
		],
		'873802': [
			{
				'name': 'overallScore',
				'coverageThreshold': 0,
				'coverage': 0.673171,
				'total': 7.7
			},
			{
				'name': 'carbonScore',
				'coverageThreshold': 0,
				'coverage': 0.6425730000000001,
				'total': 33
			}
		],
		'874744': [
			{
				'name': 'overallScore',
				'coverageThreshold': 0,
				'coverage': 0.673171,
				'total': 7.8
			},
			{
				'name': 'carbonScore',
				'coverageThreshold': 0,
				'coverage': 0.6425730000000001,
				'total': 32
			}
		]
	},
	BENCHMARK_ESG_SCORE: {
		'874741': [
			{
				'name': 'overallScore',
				'coverageThreshold': 0,
				'coverage': 0.854352,
				'total': 7.0
			},
			{
				'name': 'carbonScore',
				'coverageThreshold': 0,
				'coverage': 0.826489,
				'total': 0.6197
			}
		],
		'874742': [
			{
				'name': 'overallScore',
				'coverageThreshold': 0,
				'coverage': 0.323189,
				'total': 7.0
			},
			{
				'name': 'carbonScore',
				'coverageThreshold': 0,
				'coverage': 0.284122,
				'total': 0.6129
			}
		],
		'874743': [
			{
				'name': 'overallScore',
				'coverageThreshold': 0,
				'coverage': 0.484405,
				'total': 7.0
			},
			{
				'name': 'carbonScore',
				'coverageThreshold': 0,
				'coverage': 0.453222,
				'total': 0.6363
			}
		],
		'873802': [
			{
				'name': 'overallScore',
				'coverageThreshold': 0,
				'coverage': 0.673171,
				'total': 7.1
			},
			{
				'name': 'carbonScore',
				'coverageThreshold': 0,
				'coverage': 0.6425730000000001,
				'total': 0.6470
			}
		],
		'874744': [
			{
				'name': 'overallScore',
				'coverageThreshold': 0,
				'coverage': 0.673171,
				'total': 7.1
			},
			{
				'name': 'carbonScore',
				'coverageThreshold': 0,
				'coverage': 0.6425730000000001,
				'total': 0.64
			}
		]
	},
	DATE_FORMAT: 'D/MM/YYYY',
	SHOW_PDF_MODULARITY_FOOTNOTE: true,
	SHOULD_LOAD_MODEL_FAMILIES_FROM_IRETIRE_SERVER: false,
	PDF_RISK_PROFILE_MODULARITY_FAMILIES: ['10222', '946534'],
	EQUITIES_ASSET_CLASSES: ['Australian Equities', 'Developed Market Equities', 'Emerging Market Equities', 'Property & Infrastructure'],
	FIXED_INCOME_ASSET_CLASSES: ['Australian Fixed Income', 'International Fixed Income', 'Global Fixed Income', 'Alternatives', 'Cash & Cash Alternatives', 'Cash']
};
